export default __webpack_public_path__ + "49d6e52f719338a0fca885d11ad2f60d.jpg";